import { GET_JUDGES_COMMITTEE, GET_JUDGES_COMMITTEE_SUCCESS, GET_CONTESTEE_FEED, GET_CONTESTEE_FEED_SUCCESS, GET_CONTEST_DETAIL, GET_CONTEST_DETAIL_SUCCESS, RESET_CONTEST_DETAIL, GET_ENROLLED_HOST_DATA, GET_ENROLLED_HOST_DATA_SUCCESS, SEE_MORE_DATA, SEE_MORE_DATA_SUCCESS, GET_CONTEST_DETAIL_MONTHLY_WINNERS, GET_CONTEST_DETAIL_MONTHLY_WINNERS_SUCCESS, GET_VOTERS_ACTIVITY, GET_VOTERS_ACTIVITY_SUCCESS, GET_CONTEST_DETAIL_TALENTS, GET_CONTEST_DETAIL_TALENTS_SUCCESS, CONTEST_DETAIL_ERROR } from "../constants/actionTypes";

export const getContestDetail = payload => ({
    type: GET_CONTEST_DETAIL,
    payload
})

export const getContestDetailSuccess = payload => ({
    type: GET_CONTEST_DETAIL_SUCCESS,
    payload
})

export const getContestDetailsTalents = payload => ({
    type: GET_CONTEST_DETAIL_TALENTS,
    payload
})

export const getContestDetailsTalentsSuccess = payload => ({
    type: GET_CONTEST_DETAIL_TALENTS_SUCCESS,
    payload
})

export const getContestDetailMonthlyWinners = payload => ({
    type: GET_CONTEST_DETAIL_MONTHLY_WINNERS,
    payload
})

export const getContestDetailMonthlyWinnersSuccess = payload => ({
    type: GET_CONTEST_DETAIL_MONTHLY_WINNERS_SUCCESS,
    payload
})

export const getVotersActivity = payload => ({
    type: GET_VOTERS_ACTIVITY,
    payload
})

export const getVotersActivitySuccess = payload => ({
    type: GET_VOTERS_ACTIVITY_SUCCESS,
    payload
})

export const getJudgesCommittee = () => ({
    type: GET_JUDGES_COMMITTEE
});

export const getJudgesCommitteeSuccess = payload => ({
    type: GET_JUDGES_COMMITTEE_SUCCESS,
    payload: payload
});

export const getContesteeFeed = () => ({
    type: GET_CONTESTEE_FEED
});

export const getContesteeFeedSuccess = payload => ({
    type: GET_CONTESTEE_FEED_SUCCESS,
    payload: payload
});

export const resetContestDetail = payload => ({
    type: RESET_CONTEST_DETAIL,
    payload: payload
});

export const getEnrolledContestData = () => ({
    type: GET_ENROLLED_HOST_DATA,
})

export const getEnrolledContestDataSuccess = payload => ({
    type: GET_ENROLLED_HOST_DATA_SUCCESS,
    payload
})

export const seeMoreData = payload => ({
    type: SEE_MORE_DATA,
    payload
})

export const seeMoreDataSuccess = payload => ({
    type: SEE_MORE_DATA_SUCCESS,
    payload
})

export const contestDetailError = () => ({
    type: CONTEST_DETAIL_ERROR
});